<template>
  <div class="flex items-center">
    <ts-select
      placeholder="More"
      :size="size"
      :value="value"
      :style="{ width: width ? `${width}px` : undefined }"
      class="project-status-select"
      :class="[value]"
      @change="handleValueChange"
    >
      <el-option v-for="filter in filters" :key="filter.id" :label="filter.name" :value="filter.id"></el-option>
    </ts-select>
  </div>
</template>

<style lang="scss" scoped>
.mr-4 {
  margin-right: 1rem;
}
.label {
  height: 14px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #6d7587;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.flex {
  display: flex;
}
.project-status-disabled {
  box-shadow: inset -5px -5px 10px 0 #fafbff, inset 5px 5px 10px 0 #a6abbd;
  border-radius: 47px;
  display: inline-block;
  .title {
    user-select: none;
    text-align: center;
    border-radius: 16px;
    line-height: 18px;
    padding: 4px 16px;
    font-size: 12px;
    // box-shadow: 5px 5px 10px 0 rgb(166 171 189 / 48%), -5px -5px 10px 0 rgb(250 251 255 / 80%);
    border: solid 2px rgba(255, 255, 255, 0.16);
    background-blend-mode: soft-light, normal;
    background-clip: padding-box;
    background: #ebecf0;
    background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  }
}
.project-status-select::v-deep,
.project-status-disabled {
  width: 120px;

  .el-input .el-select__caret {
    color: black;
  }

  &.started {
    .el-input__inner,
    .title {
      background-color: #99ffd1;
      color: black;
    }
  }

  &.on-hold {
    .el-input__inner,
    .title {
      background-color: #fe9a90;
      color: black;
    }
  }

  &.production {
    .el-input__inner,
    .title {
      background-color: #6ee1ff;
      color: black;
    }
  }

  &.delivered,
  .title {
    .el-input__inner {
      background-color: #99ffd1;
      color: black;
    }
  }

  &.not-started {
    .el-input__inner,
    .title {
      background-color: #f7ffbc;
      color: black;
    }
  }
}
</style>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: 'mini'
    },
    width: {
      type: Number,
      default: 80
    }
  },
  data() {
    return {
      filters: [
        { name: 'Platform', id: 'handleSelectPlatformClick' },
        { name: 'Download', id: 'handleDownloadAssetsClick' },
        { name: 'Delete', id: 'handleDeleteAssetsClick' }
      ]
    };
  },
  computed: {
    selectableStatuses() {
      return this.filters.filter(filter => filter.id === this.value);
    }
  },
  methods: {
    handleValueChange(value) {
      this.$emit('input', value);
    }
  }
};
</script>
